module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.client.id) ? _c('v-list-tile', {
    key: _vm.client.id,
    nativeOn: {
      "click": function($event) {
        return _vm.$emit("listitem:clicked", _vm.client)
      }
    }
  }, [_vm._t("avatar", function() {
    return [(_vm.withGravatar && _vm.client.email) ? _c('v-list-tile-avatar', [_c('v-avatar', [_c('img', {
      attrs: {
        "src": _vm.getGravatar(_vm.client.email)
      }
    })])], 1) : _vm._e()]
  }), _vm._v(" "), (_vm.withEdit && _vm.relationshipId) ? _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "small": "",
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.launchCustomerDetailsDialog(_vm.relationshipId, true)
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._t("after-before"), _vm._v(" "), _c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('strong', [_vm._v("\n          " + _vm._s(_vm.fullName) + "\n          "), (hover) ? _c('small', {
          staticClass: "grey--text"
        }, [(_vm.client.custom_id) ? _c('span', [_vm._v("\n              / #" + _vm._s(_vm.client.custom_id) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.client.phone_number) ? _c('span', [_vm._v("\n              / " + _vm._s(_vm.client.phone_number) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isRealEmail(_vm.client.email)) ? _c('span', {
          attrs: {
            "span": ""
          }
        }, [_vm._v("\n              / " + _vm._s(_vm.client.email) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.relationshipId) ? _c('span', [_vm._v("\n              / # " + _vm._s(_vm.relationshipId) + "\n            ")]) : _vm._e()]) : _vm._e()])]
      }
    }], null, false, 2417675565)
  }), _vm._v(" "), _vm._t("after-title")], 2), _vm._v(" "), _vm._t("subtitle", function() {
    return [(_vm.withDetails) ? _c('v-list-tile-sub-title', [(_vm.client.phone_number) ? _c('span', {
      attrs: {
        "small": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.$emit("phoneClicked", _vm.client.phone_number)
        }
      }
    }, [_c('v-icon', {
      staticClass: "hidden-xs-only",
      attrs: {
        "small": ""
      }
    }, [_vm._v("phone")]), _vm._v("\n        " + _vm._s(_vm.client.phone_number) + "\n      ")], 1) : _vm._e(), _vm._v(" "), (_vm.isRealEmail(_vm.client.email)) ? _c('span', {
      attrs: {
        "small": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.$emit("emailClicked", _vm.client.email)
        }
      }
    }, [_c('v-icon', {
      staticClass: "hidden-xs-only",
      attrs: {
        "small": ""
      }
    }, [_vm._v("mail")]), _vm._v(" " + _vm._s(_vm.client.email))], 1) : _vm._e()]) : _vm._e()]
  }), _vm._v(" "), _vm._t("extrasubtitle")], 2), _vm._v(" "), _vm._t("actions"), _vm._v(" "), _c('space-faces', {
    attrs: {
      "tooltip-prefix": "Shared with ",
      "space-ids": _vm.spaces,
      "size": 16
    }
  }), _vm._v(" "), (_vm.owner) ? _c('v-divider', {
    staticClass: "mx-2",
    attrs: {
      "vertical": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.owner) ? _c('practitioner-faces', {
    attrs: {
      "tooltip-prefix": "Owned by ",
      "practitioner-ids": [_vm.owner],
      "size": 16
    }
  }) : _vm._e(), _vm._v(" "), (_vm.withWhatsApp) ? [_c('v-divider', {
    staticClass: "ml-3",
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), (_vm.client.phone_number) ? _c('whats-app-btn', {
    attrs: {
      "small": "",
      "number": _vm.client.phone_number,
      "classes": "mr-0"
    }
  }) : _c('v-btn', {
    staticClass: "mr-0",
    attrs: {
      "disabled": "",
      "flat": "",
      "icon": "",
      "small": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("whatsapp")])], 1)] : _vm._e(), _vm._v(" "), (_vm.withAction) ? _c('v-list-tile-action', [_vm._t("action", function() {
    return [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.$emit("listitem:goclicked", _vm.client)
        }
      }
    }, [_c('v-icon', {
      staticClass: "grey--text text--lighten-1"
    }, [_vm._v("chevron_right")])], 1)]
  })], 2) : _vm._e()], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f42f491","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/ClientListItem.vue
// module id = 1376
// module chunks = 9